"use client";

import { createContext, useContext, useState, ReactNode } from "react";

interface DbContextType {
  addingDB: boolean;
  setIsAddingDB: React.Dispatch<React.SetStateAction<boolean>>;
}

const dbContext = createContext<DbContextType | undefined>(undefined);

export const DbContextProvider = ({ children }: { children: ReactNode }) => {
  const [addingDB, setIsAddingDB] = useState(false);

  return (
    <dbContext.Provider value={{ addingDB, setIsAddingDB }}>
      {children}
    </dbContext.Provider>
  );
};

export const useDbContext = () => {
  const context = useContext(dbContext);
  if (!context) {
    throw new Error("useMyContext must be used within a DbContextProvider");
  }
  return context;
};
